import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpParams } from "@angular/common/http";
import { MatDialog } from "@angular/material";

import { ApirequestService } from "../../../../../shared/services/apirequest.service";
import { ShareCollectionComponent } from "../share-collection.component";
import { MyCollectionDialogComponent } from "../my-collection-dialog.component";

@Component({
  selector: "app-reviseddashboard-list-folder-measures",
  templateUrl: "./list-folder-measures.component.html",
  styleUrls: ["./list-folder-measures.component.scss"],
})
export class RevisedDashboardListFolderMeasuresComponent implements OnInit {
  measures: Array<any>;
  interventions: Array<any>;
  behaviors: Array<any>;
  id: string;
  folder_name: string;
  page = 1;
  measuresTotal = 0;
  interventionsTotal = 0;
  behaviorsTotal = 0;
  limit = 10;
  total_pages = 0;
  url_params;
  page_size = 0;

  constructor(
    private apirequestService: ApirequestService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.id = params["id"] || "";
      this.folder_name = params["name"] || "";
      this.page = params["page"] || "1";
    });
    this.getMyMeasureCollectionFolders();
    this.getMyInterventionCollectionFolders();
    this.getMyBehaviorCollectionFolders();
  }

  goToPage(n: number): void {
    this.page = n;
    this.getMyMeasureCollectionFolders();
  }

  onNext(): void {
    this.page++;
    this.getMyMeasureCollectionFolders();
  }

  onPrev(): void {
    this.page--;
    this.getMyMeasureCollectionFolders();
  }

  shareMeasure(measure) {
    // pop up to add users
    const dialogRef = this.dialog.open(ShareCollectionComponent, {
      panelClass: "customPanelClass",
      data: {
        measure: measure,
        type: "measure",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getMyMeasureCollectionFolders();
    });
  }

  private getMyMeasureCollectionFolders() {
    this.url_params = { page: this.page.toString() };
    const params = new HttpParams().set("page", this.page.toString());
    const url = "my_collection/measure_in_folder/" + this.id + "/";
    this.apirequestService.get(url, params).subscribe(
      (res) => {
        this.measuresTotal = res.count;
        this.page_size = res.page_size;
        this.page = res.current_page;
        this.total_pages = res.total_pages;
        this.measures = res.results;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: this.url_params,
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  private getMyInterventionCollectionFolders() {
    this.url_params = { page: this.page.toString() };
    const params = new HttpParams().set("page", this.page.toString());
    const url = "my_collection/intervention_in_folder/" + this.id + "/";
    this.apirequestService.get(url, params).subscribe(
      (res) => {
        this.interventionsTotal = res.count;
        this.page_size = res.page_size;
        this.page = res.current_page;
        this.total_pages = res.total_pages;
        this.interventions = res.results;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: this.url_params,
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }
  private getMyBehaviorCollectionFolders() {
    this.url_params = { page: this.page.toString() };
    const params = new HttpParams().set("page", this.page.toString());
    const url = "my_collection/behaviour_in_folder/" + this.id + "/";
    this.apirequestService.get(url, params).subscribe(
      (res) => {
        this.behaviorsTotal = res.count;
        this.page_size = res.page_size;
        this.page = res.current_page;
        this.total_pages = res.total_pages;
        this.behaviors = res.results;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: this.url_params,
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  transform(value: string): string {
    const maxLength = 15;
    if (value.length <= maxLength) {
      return value;
    } else {
      return value.substring(0, maxLength) + "...";
    }
  }

  openMyCollectionDialogue(folder, action) {
    const dialogRef = this.dialog.open(MyCollectionDialogComponent, {
      data: {
        collectionFolder: folder,
        action: action,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getMyMeasureCollectionFolders();
    });
  }
}
